import { Icon } from '@spotnana/blocks/src/Icon';
import { Typography } from '@spotnana/blocks/src/Typography';
import { useTranslation } from 'react-i18next';
import { Button } from '@spotnana/blocks/src/Button/Button';
import useFareSelectionService from 'obt-common/xstate/flightFareSelectionMachine/useFareSelectionService';
import { AirSelectedItineraryResponseManager, IFlightCheckoutFormParams } from 'obt-common';
import { IOnFareSelectProps } from 'obt-common/xstate/flightFareSelectionMachine/types';
import { useFormContext } from 'rhf-v7';
import { Link } from '@spotnana/blocks/src/Link';
import { container, policy, close_cross } from './styles';

interface IProps {
  airSelectedItineraryResponseManager: AirSelectedItineraryResponseManager;
  handleClose: VoidFunction;
  showLLFBannerAlert: boolean;
}

const ItineraryGreaterThanLLFAlert = ({
  airSelectedItineraryResponseManager,
  handleClose,
  showLLFBannerAlert,
}: IProps) => {
  const { t: tt } = useTranslation('WEB');
  const flightFareSelectionService = useFareSelectionService();

  const legNumber = airSelectedItineraryResponseManager.GetItineraryAllLegs().length - 1;
  const { reset, getValues } = useFormContext<IFlightCheckoutFormParams>();
  const selectedRateOptionId = airSelectedItineraryResponseManager.GetRateOptionId(0);
  const handleFareSelect = ({ rateOptionId, searchId }: IOnFareSelectProps) => {
    reset({
      ...getValues(),
      lastLegRateOptionId: rateOptionId,
      searchId,
    });
  };

  const handleViewRecommendation = () => {
    flightFareSelectionService.send({
      type: 'BEGIN_SELECT',
      airSearchResponseManager: airSelectedItineraryResponseManager,
      itinIndex: 0,
      rateOptionId: selectedRateOptionId,
      feLLFImprovementsAirEnabled: true,
      onFareSelect: handleFareSelect,
      legNumber,
      searchId: airSelectedItineraryResponseManager.GetSearchId(),
    });
  };

  if (!showLLFBannerAlert) {
    return null;
  }

  return (
    <div css={container}>
      <Icon name="Policy" css={policy} />
      <Typography variant="body2">
        {tt(
          'Your company recommends a more cost-effective flight itinerary, offering similar comfort and convenience as your current selection. ',
        )}
        <Link onClick={handleViewRecommendation}>{tt('View recommendation')}</Link>
      </Typography>
      <Button variant="ghost" onClick={handleClose}>
        <Icon name="CloseCross" css={close_cross} data-testid="dismiss-alert" />
      </Button>
    </div>
  );
};

export { ItineraryGreaterThanLLFAlert };
